import React from "react";
import { motion } from "framer-motion";
import { useJourney } from "@/context/JourneyContext";
import { Gift } from "lucide-react";

export function RewardsBadge() {
  const { data } = useJourney();
  const rewards = data?.rewards || [];
  if (rewards.length === 0) return null;
  const total = rewards.reduce((s, r) => s + (r.value || 0), 0);
  return (
    <motion.div
      data-testid="rewards-badge"
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      className="fixed top-9 left-5 z-40 flex items-center gap-2 rounded-full glass px-4 py-2 shadow-lg"
      title={rewards.map((r) => `${r.name} — $${r.value}`).join("\n")}
    >
      <Gift size={14} className="text-brand" />
      <span className="text-xs font-medium text-forest">
        My Home Rewards — ${total.toLocaleString()} Unlocked
      </span>
    </motion.div>
  );
}
